.dark-calendar .react-datepicker__time-box {
  border-radius: 16px;
  border: solid 1px rgba(144, 148, 165, 1);
  background-color: rgba(18, 18, 22, 1);
}

.calendar .react-datepicker__time-box {
  border-radius: 16px;
  border: solid 1px rgba(221, 224, 234, 1);
  background-color: rgba(255, 255, 255, 1);
}

.react-datepicker-time__header {
  display: none;
}

.dark-time-select {
  background: rgba(18, 18, 22, 1);
  padding: 16px;
  color: rgba(255, 255, 255, 1);
}

.time-select {
  background: rgba(255, 255, 255, 1);
  padding: 16px;
}

.react-datepicker__aria-live {
  position: absolute;
  clip-path: circle(0);
  border: 0;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  width: 1px;
  white-space: nowrap;
}

.react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box
  ul.react-datepicker__time-list {
  height: 500px;
  overflow-y: scroll;
  list-style-type: none;
  padding-left: 0px;
}

.react-datepicker__time-list-item {
  font-family: 'DMSans-Regular';
  margin-left: 8px;
  margin-right: 16px;
}

.dark-calendar .react-datepicker__time-list-item--selected {
  border-radius: 8px;
  border: 1px solid rgba(58, 61, 74, 1);
  background-color: rgba(30, 30, 34, 1);
}

.dark-calendar .react-datepicker__time-list-item--disabled {
  color: rgba(58, 61, 74, 1);
}

.calendar .react-datepicker__time-list-item--selected {
  border-radius: 8px;
  border: 1px solid rgba(221, 224, 234, 1);
  background-color: rgba(249, 249, 253, 1);
}

.calendar .react-datepicker__time-list-item--disabled {
  color: rgba(221, 224, 234, 1);
}
